@for (sale of salesData()?.sales; let i = $index; track sale.id) {
    <div class="tw:mb-4 tw:rounded-lg tw:bg-primary-50 tw:p-4">
        <div class="tw:flex tw:justify-between tw:items-center">
            <div class="tw:flex tw:gap-4">
                <app-icon icon="receipt" [inCircle]="true" class="tw:text-primary-600" />
                <div>
                    <div class="tw:font-bold tw:text-primary-500">{{ sale.invoiceReference || sale.code }}</div>
                    <div class="tw:text-sm tw:text-neutral-500 tw:flex tw:gap-2">
                        <div>{{ sale.createdAt | date: 'short' }}</div>
                        <div>·</div>
                        @if (sale.status === ISaleStatus.PENDING_PAYMENT) {
                            <div class="tw:text-error-800">
                                {{ 'SALES_STATUS.pending' | translate }}: {{ sale.total - sale.paidAmount | merchantCurrency }}
                            </div>
                        }
                        <div>{{ 'GENERAL.total' | translate }}: {{ sale.total | merchantCurrency }}</div>
                    </div>
                </div>
            </div>
            <div class="tw:flex tw:gap-4 tw:items-center">
                <app-sales-status [sale]="sale" />
                <app-button type="transparent" size="sm" (clickEvent)="sale.expanded ? (sale.expanded = false) : (sale.expanded = true)">
                    <app-icon icon="keyboard_arrow_down" />
                </app-button>
            </div>
        </div>
        @if (sale.expanded) {
            <div class="tw:mt-4 tw:grid tw:grid-cols-2 tw:gap-4">
                <app-invoice-preview [fixedSaleData]="sale" [showEditPaymentButton]="true" [showSendPaymentLinkButton]="false" />

                <div class="tw:bg-white tw:p-2 tw:rounded-lg">
                    <app-sale-detail-documents [sale]="sale" />
                    
                    <app-sale-detail-actions (saleUpdated)="saleUpdated()" (closeParent)="closeModal()" [sale]="sale" />

                </div>
            </div>
        }
    </div>
}

@if (salesData()?.sales.length === 0) {
    <div class="tw:text-neutral-500 tw:text-sm py-5 text-center">
        <app-icon icon icon="receipt" extraClass="tw:text-primary tw:text-2xl" />
        <div class="tw:font-semibold tw:my-2">{{ 'CLIENT_SALES.emptyState.title' | translate }}</div>
        <div>{{ 'CLIENT_SALES.emptyState.description' | translate }}</div>
    </div>
}
